import { createI18n } from 'vue-i18n';

function loadLocaleMessages() {
  const locales = import.meta.glob('./locales/*.json', { eager: true });
  const messages = {};

  Object.keys(locales).forEach(path => {
    const language = path.match(/\D{2}(?=\.json)/);
    messages[language[0]] = locales[path];
  });
  return messages;
}

export default createI18n({
  locale: import.meta.env.VITE_I18N_LOCALE || 'en',
  fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages(),
});
